export const PLACEHOLDER_IMAGE = '/template/cn/index/img/grey.gif'
/** @deprecated Kept for callers that still compare against the old fallback path. Never returned as a substitute image. */
export const LOCAL_FALLBACK_IMAGE = ''

const BLOCKED_IMAGE_MARKERS = [
  'grey.gif',
  'banner-products.png',
  'banner-news.png',
  'placeholder-case',
  'placeholder',
  'i-bg1.png',
  'i-bg2.jpg'
]

/** True when URL is empty or a known legacy/default placeholder — not a real CMS upload. */
export function isMissingOrFallbackImage(url) {
  if (!url) return true
  const u = String(url)
  return BLOCKED_IMAGE_MARKERS.some(marker => u.includes(marker))
}

/** Only remaps real brand logos; never substitutes content images. */
const LOCAL_ASSETS = {
  '/uploads/image/20251030/0458690ce0ef368a3e6e6011300e0f3f.svg': '/images/logo.png',
  '/uploads/image/20251030/75ae05002e6bfecec0fb15bac221cc24.svg': '/images/logo.png'
}

const HIRAYS_HOST_RE = /(?:https?:)?\/\/(?:www\.)?hirays\.com/i

/** True if URL still points at the old hirays.com CDN */
export function isHiraysExternalUrl(path) {
  return !!(path && HIRAYS_HOST_RE.test(String(path)))
}

export function stripHiraysHost(path) {
  if (!path) return ''
  return String(path)
    .trim()
    .replace(/^https?:\/\/(?:www\.)?hirays\.com/i, '')
    .replace(/^\/\/(?:www\.)?hirays\.com/i, '')
}

/**
 * Resolve CMS / relative media to a site-local URL.
 * Never invents a default image — missing/legacy paths resolve to ''.
 */
export function resolveMediaUrl(path) {
  if (!path) return ''
  const raw = String(path).trim()
  if (isHiraysExternalUrl(raw)) {
    const stripped = stripHiraysHost(raw)
    if (LOCAL_ASSETS[stripped]) return LOCAL_ASSETS[stripped]
    return ''
  }

  let p = stripHiraysHost(raw)
  if (!p) return ''
  if (/hirays\.com/i.test(p)) return ''

  if (/^https?:\/\//i.test(p)) {
    return isMissingOrFallbackImage(p) ? '' : p
  }

  if (LOCAL_ASSETS[p]) return LOCAL_ASSETS[p]
  if (p.startsWith('/images/') || p.startsWith('/template/') || p.startsWith('/img/')) {
    return isMissingOrFallbackImage(p) ? '' : p
  }

  if (p.startsWith('/profile')) {
    return p
  }

  if (p.startsWith('/uploads') || p.startsWith('uploads/')) {
    const normalized = p.startsWith('/') ? p : '/' + p
    if (LOCAL_ASSETS[normalized]) return LOCAL_ASSETS[normalized]
    // Unmapped legacy uploads are not substituted with a default image
    return ''
  }

  return isMissingOrFallbackImage(p) ? '' : p
}

/** Resolve CMS image; returns '' when missing so callers can hide the media block. */
export function resolveCmsImageUrl(path) {
  const url = resolveMediaUrl(path)
  if (isMissingOrFallbackImage(url)) return ''
  return url
}

export function resolveMediaList(path) {
  if (!path) return []
  return String(path)
    .split(',')
    .map(s => s.trim())
    .filter(Boolean)
    .map(resolveMediaUrl)
    .filter(Boolean)
}

/** Strip hirays.com images from HTML bodies (remove src / url, do not substitute defaults). */
export function stripHiraysMediaFromHtml(html) {
  if (!html) return ''
  let s = String(html)
  s = s.replace(
    /<img\b[^>]*\bsrc\s*=\s*["'](?:https?:)?\/\/(?:www\.)?hirays\.com[^"']*["'][^>]*>/gi,
    ''
  )
  s = s.replace(
    /(url\(\s*['"]?)(?:https?:)?\/\/(?:www\.)?hirays\.com[^'")\s]+(['"]?\s*\))/gi,
    '$1$2'
  )
  s = s.replace(
    /((?:src|data-src|data-original|poster)\s*=\s*["'])(?:https?:)?\/\/(?:www\.)?hirays\.com[^"']*(["'])/gi,
    '$1$2'
  )
  return s
}

/** No static page-banner defaults — only CMS uploads (via siteMedia) are used. */
export const PAGE_BANNERS = {
  product: '',
  news: '',
  solution: '',
  about: '',
  contact: '',
  service: ''
}
